<template>
  <ul :class="className">
    <li class="flex">
      <span class="w-6 mr-2">
        <svg width="24" height="24" class="fill-current mr-2">
          <use xlink:href="/img/sprite.svg#ic_snorkel"></use>
        </svg>
      </span>
      <span> Diving and other activities can be added on request </span>
    </li>
    <li class="flex">
      <span class="w-6 mr-2">
        <svg width="24" height="24" class="fill-current mr-2">
          <use xlink:href="/img/sprite.svg#ic_chat"></use>
        </svg>
      </span>
      <span> Free expert travel advice and support </span>
    </li>
    <li class="flex">
      <span class="w-6 mr-2">
        <svg width="24" height="24" class="inline-block mr-3">
          <use xlink:href="/img/sprite.svg#ic_deal" />
        </svg>
      </span>
      <span> Best price guarantee </span>
    </li>
    <li class="flex">
      <img
        class="mr-2"
        width="24"
        height="24"
        src="/img/ic_credit-card.svg"
        alt="check"
      />
      <span> Reserve now, pay later </span>
    </li>
  </ul>
</template>

<script>
export default {
  props: ["className"],
};
</script>

<style scoped>
li {
  margin: 0px !important;
}
</style>
